import React from "react";

export const MyLeaveCalendarPathOutlineAfter: React.FC<{ color: string }> = ({ color }) => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m 3.133297,26.993101 -3.13176799,-0.0059 0.0022,-1.975525 3.12959499,-0.01854 c 0.55259,-0.0033 1.0807,-0.2287 1.4588,-0.6318 l 8.90998,-9.5 c 0.7217,-0.7694 0.7217,-1.967 0,-2.7364 L 4.592097,2.6249007 c -0.3781,-0.4031 -0.9062,-0.6318 -1.4588,-0.6318 L 0.00459101,1.9857007 -8.9875e-6,0.00633268 3.133306,-5.67324e-4 C 4.238603,-0.00296732 5.294706,0.45053268 6.0508462,1.2567327 l 8.9100398,9.5000003 c 1.443305,1.5388 1.443305,3.934 0,5.4728 l -8.9100398,9.5 C 5.294697,26.535702 4.238597,26.993101 3.133297,26.993101 Z"
      fill={color}
    />
  );
};

export default MyLeaveCalendarPathOutlineAfter;
